export const hotCityList = [
  {
    name: '鄂尔多斯',
    key: 1,
    data: [
      {
        code: '040',
        id: '000000000015',
        name: '内蒙古自治区',
      },
      {
        code: '000000001506',
        id: '000000001506',
        name: '鄂尔多斯市',
      },
    ],
  },
  {
    name: '合肥',
    key: 2,
    data: [
      {
        code: '110',
        id: '000000000034',
        name: '安徽省',
      },
      {
        code: '000000003401',
        id: '000000003401',
        name: '合肥市',
      },
    ],
  },
  {
    name: '曲靖',
    key: 3,
    data: [
      {
        code: '240',
        id: '000000000053',
        name: '云南省',
      },
      {
        code: '000000005303',
        id: '000000005303',
        name: '曲靖市',
      },
    ],
  },
  {
    name: '昆明',
    key: 4,
    data: [
      {
        code: '240',
        id: '000000000053',
        name: '云南省',
      },
      {
        code: '000000005301',
        id: '000000005301',
        name: '昆明市',
      },
    ],
  },
  {
    name: '连云港市',
    key: 5,
    data: [
      {
        code: '100',
        id: '000000000032',
        name: '江苏省',
      },
      {
        code: '000000003207',
        id: '000000003207',
        name: '连云港市',
      },
    ],
  },
  {
    name: '广州市',
    key: 6,
    data: [
      {
        code: '190',
        id: '000000000044',
        name: '广东省',
      },
      {
        code: '000000004401',
        id: '000000004401',
        name: '广州市',
      },
    ],
  },
  {
    name: '宁波',
    key: 7,
    data: [
      {
        code: '130',
        id: '000000000033',
        name: '浙江省',
      },
      {
        code: '000000003302',
        id: '000000003302',
        name: '宁波市',
      },
    ],
  },
  {
    name: '西安市',
    key: 8,
    data: [
      {
        code: '250',
        id: '000000000061',
        name: '陕西省',
      },
      {
        code: '000000006101',
        id: '000000006101',
        name: '西安市',
      },
    ],
  },
];

export interface DetermineFace {
  name: string;
  id?: string;
  code?: string;
}

export interface ListDetermineFace {
  name: string;
  key: number;
  data: DetermineFace[];
}

export interface CategoryListFace {
  firstCityCategoryList: string;
  secondCityCategoryList: string;
  thirdCityCategoryList: string;
  moDeId?: number | null;
  cityId?: string;
}

export interface LevelFace {
  CODE: string;
  CODE_DESC: string;
  LEVEL: number;
  ID: string;
}

export interface ValuesFace {
  values: ColumnsFace[] | string[];
  defaultIndex?: number;
}
export interface ColumnsFace {
  name: string;
  id: string;
  code: number | string;
}

export interface ValueEquipmentFace {
  values: EquipmentFace[];
  defaultIndex?: number;
}

export interface EquipmentFace {
  deviceId: number;
  deviceMode: string;
  name: string;
  deviceCategoryId?: number;
}
